var __jsx = React.createElement;
import React from "react";
var DocumentSVG = function DocumentSVG(_ref) {
  var _ref$filledColor = _ref.filledColor,
    filledColor = _ref$filledColor === void 0 ? "#154F9C" : _ref$filledColor,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className;
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className ? className : ""
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.897 7.21208L19.8971 7.21205L19.8948 7.20972L14.9674 2.0408C14.9674 2.04076 14.9674 2.04073 14.9674 2.0407C14.8584 1.92603 14.7072 1.85508 14.5472 1.85508H6.74521C5.25055 1.85508 4.01719 3.08324 4.01719 4.57822V19.3318C4.01719 20.8269 5.25055 22.0551 6.74521 22.0551H17.3345C18.8292 22.0551 20.0625 20.8269 20.0625 19.3318V7.61685C20.0625 7.46092 19.9912 7.31746 19.897 7.21208ZM15.135 5.9744V3.91036L18.1012 7.02415H16.1896C15.6066 7.02415 15.135 6.55628 15.135 5.9744ZM17.3345 20.8889H6.74521C5.89655 20.8889 5.18337 20.1843 5.18337 19.3318V4.57822C5.18337 3.73032 5.89204 3.02126 6.74521 3.02126H13.9688V5.9744C13.9688 7.20378 14.9609 8.19033 16.1896 8.19033H18.8963V19.3318C18.8963 20.1845 18.1879 20.8889 17.3345 20.8889Z",
    fill: filledColor,
    stroke: filledColor,
    strokeWidth: "0.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0168 17.5548H8.06512C7.74426 17.5548 7.48203 17.8168 7.48203 18.1379C7.48203 18.4588 7.74424 18.721 8.06512 18.721H16.0217C16.3426 18.721 16.6048 18.4588 16.6048 18.1379C16.6048 17.8162 16.3419 17.5548 16.0168 17.5548Z",
    fill: filledColor,
    stroke: filledColor,
    strokeWidth: "0.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6129 15.991L11.6129 15.991L11.6137 15.9918C11.7231 16.1068 11.8743 16.1775 12.0388 16.1775C12.2033 16.1775 12.3546 16.1069 12.4639 15.9917L12.4646 15.991L15.2949 12.9531C15.295 12.953 15.2951 12.9528 15.2953 12.9527C15.5175 12.7182 15.4992 12.3458 15.2666 12.1301C15.0321 11.9079 14.6594 11.9261 14.4438 12.1592C14.4438 12.1592 14.4437 12.1593 14.4437 12.1593L12.6219 14.1133V9.09198C12.6219 8.77092 12.3596 8.50889 12.0388 8.50889C11.7179 8.50889 11.4557 8.77092 11.4557 9.09198V14.1129L9.63855 12.1591L9.63855 12.1591L9.63781 12.1583C9.41799 11.927 9.05035 11.9072 8.81529 12.1306C8.58409 12.3503 8.56423 12.7176 8.78718 12.9527C8.78731 12.9529 8.78744 12.953 8.78757 12.9531L11.6129 15.991Z",
    fill: filledColor,
    stroke: filledColor,
    strokeWidth: "0.2"
  }));
};
export default DocumentSVG;